"use es6";

import { isSVGElement } from "../../render/dom/utils/is-svg-element";
import { SVGVisualElement } from "../../render/svg/SVGVisualElement";
import { HTMLVisualElement } from "../../render/html/HTMLVisualElement";
import { visualElementStore } from "../../render/store";
function createVisualElement(element) {
  const options = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  };
  const node = isSVGElement(element) ? new SVGVisualElement(options, {
    enableHardwareAcceleration: false
  }) : new HTMLVisualElement(options, {
    enableHardwareAcceleration: true
  });
  node.mount(element);
  visualElementStore.set(element, node);
}
export { createVisualElement };